import React from 'react';
import { 
  CommonActions, 
  createNavigationContainerRef,
  NavigationContainer 
} from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';

const Stack = createStackNavigator();

import * as ht from './_ht';
import * as hf from './_hf';
import * as cr from './_cr';

import * as _cmCPT from './_cmCPT';
import * as _hmB64 from './_hmB64';

import * as icv from 'src/icv';

const $ngnRef = createNavigationContainerRef();

const _NgnRoot = (pd: { // navigation root
  ls: {
    pageName: ht.s,
    pfx: ht.s,
    oCpt: ht.o,
  }[]
}) => {
  const _ls = pd.ls.map( (_dz, _nIdx) => (
    cr.c(Stack.Screen, {
      key: _nIdx,
      name: _dz.pageName,
      component: _dz.oCpt,
      options: {
        title: _dz.pfx ?? icv.appName ?? _dz.pageName ?? '',
        headerShown: false, 
        animationEnabled: false,
      },
    })
  ));

/*
  React.useEffect(() => {
    const _ssb = $ngnRef.addListener('transitionEnd', (e) => {
      hf.s(`csNgn 44: ${hf.s($ngnRef?.getCurrentRoute()?.params)}`);
    });
    return _ssb;
  }, [
    $ngnRef,
  ])
*/

  return (
      cr.c(NavigationContainer, {
        key: 'Ngn.root',
        ref: $ngnRef,
        linking: {
/*
          config: {
            screens: {
              login: '/login/:dmnName', // domain name
            }
          }
*/
        },
/*
        onReady: () => {
          hf.l(`csNgn 67: hello. I'm ready`);
        },
*/
      }, 
        cr.c(Stack.Navigator, {
          key: -10,
        },
          _ls
        )
      )
  );
};
export default _NgnRoot;

/*

import * as ht from './_ht';
*/

const $waitReadyAsync = async (): Promise<ht.b> => {
  if ($ngnRef.isReady()) {
    return true;
  }
  else {
    await hf.waitAsync(100);
    return await $waitReadyAsync();
  }
};

export const useNgnz = () => {

  const _dph = (pPrmz: ht.a) => { // dispatch
    if ($ngnRef.isReady()) {
      $ngnRef.dispatch(pPrmz);
    }
  };

/*
  const _getName = () => { // get name
    if ( $ngnRef.isReady() ) {
      return $ngnRef?.getCurrentRoute()?.name;
    }
    else {
      return null;
    } 
  };
*/
  const _getNameAsync = async () => { // get name
    await $waitReadyAsync();
    return $ngnRef?.getCurrentRoute()?.name ?? 'NoName';
  };

/*
  const _getPmrz = (
    key?: ht.a
  ) => { // get parameter
    //hf.l(`csNgn 89: here`)
    const _pmrz = $ngnRef?.getCurrentRoute()?.params as ht.dz; // isReady 関係なく取得可能
    //hf.l(`csNgn 110: ${hf.s(_pmrz)}`)
    if ( $ngnRef.isReady() ) {
      //hf.l(`csNgn 91: here`)
      //const _pmrz = $ngnRef?.getCurrentRoute()?.params as ht.dz;
      if (key && _pmrz) {
        //hf.l(`csNgn 93: here`)
//        return $ngnRef?.getCurrentRoute()?.params[key];
        return _pmrz[key];
      }
      else {
        //hf.l(`csNgn 97: here`)
//        return $ngnRef?.getCurrentRoute();
        return _pmrz;
      }
    } 
    else {
      //hf.l(`csNgn 102: here`)
//      return null;
      return _pmrz;
    }
  };
*/

  const _getPmrzAsync = async (
    key?: ht.a
  ) => { // get parameter
    //hf.l(`csNgn 89: here`)
    await $waitReadyAsync();
    const _pmrz = $ngnRef?.getCurrentRoute()?.params as ht.dz; // isReady 関係なく取得可能
    if (key && _pmrz) {
      return _pmrz[key];
    }
    else {
      return _pmrz;
    }
  };

  const _ngt = (
    name: never, 
    pmrz: never
  ) => { // navigate
    if ( $ngnRef.isReady() ) {
      $ngnRef.navigate(name, pmrz);
    }
  };

/*
  const _moveTo = (pz: { // RNW の再描画を考慮し、myLS は不使用
    pageName: ht.s,
    prmz?: ht.dz,
  }) => new Promise( _o_end1 => { // 子に渡す変数を pd_vals に指定
    if (pz.pageName != _getName()) { // 異なる画面の場合のみ遷移
      const _srt = `joizaFFG${icv.appName}fGAfgFGve3${icv.appName}`; // app ごとに異なる srt とする
      let _prmz = null;
      if (pz.prmz) {
        _prmz = hf.s(pz.prmz);
        _prmz = cpt.ect(_prmz, _srt);
        _prmz = b64.cnvSrgToB64(_prmz); // base64 に変換しないと通らない
      }
      _dph( // navigate 前に dispatch
        CommonActions.reset({ // web の戻る操作を無効化
          index: 0,
          routes: [{
            name: pz.pageName,
            params: { prmz: _prmz },
          }]
        })
      );
      _ngt(
        pz.pageName as never,
        { prmz:  _prmz } as never,
      );
      //
      _o_end1(null);
    }
  });
*/
  const _moveTo = (pz: { // RNW の再描画を考慮し、myLS は不使用
    pageName: ht.s,
    pmrz?: ht.dz,
    bEct?: ht.b, // encrypt
  }) => new Promise( _o_end1 => { // 子に渡す変数を pd_vals に指定
    _getNameAsync()
    .then((_name: ht.s) => {
      if (pz.pageName != _name) { // 異なる画面の場合のみ遷移
        let _pmrz = undefined;
        if (pz.pmrz) {
          if (!pz.bEct) {
            _pmrz = pz.pmrz;
          }
          else {
            const _srt = `joizaFFG${icv.appName}fGAfgFGve3${icv.appName}`; // app ごとに異なる srt とする
            let _pmr = hf.s(pz.pmrz);
            _pmr = _cmCPT.ect(_pmr, _srt);
            _pmr = _hmB64.cvtSrgToB64(_pmr); // base64 に変換しないと通らない
            _pmrz = { prmz: _pmr }
          }
        }
        _dph( // navigate 前に dispatch
          CommonActions.reset({ // web の戻る操作を無効化
            index: 0,
            routes: [{
              name: pz.pageName,
              params: _pmrz,
            }]
          })
        );
        _ngt(
          pz.pageName as never,
          _pmrz as never,
        );
        //
        _o_end1(null);
      }
    })
  });

  return {
    ref: $ngnRef,
    moveTo: _moveTo,
//    getPrmz: _getPmrz, // 廃止予定
    getPmrzAsync: _getPmrzAsync,
    getNameAsync: _getNameAsync,
  }

}